module.exports = __webpack_public_path__ + "img/linhas_background.980d534f.png";